import React from "react";
import type { ReactNode } from "react";
import { localPemissions } from "../localPemissions/localPemissions";
import { LocalPemissionName } from "../types/LocalPemissions";
import { baseUrlName } from "../../routes/baseUrl";

type HasLocalAccess = (localPermission: LocalPemissionName[] | LocalPemissionName) => boolean;

type HasLocalAccessNode = (
  localPermission: LocalPemissionName[] | LocalPemissionName,
  node: ReactNode
) => ReactNode | null;

export const hasLocalAccess: HasLocalAccess = (localPermission) => {
  if (Array.isArray(localPermission)) {
    return localPermission.every((localPermissionItem) =>
      localPemissions[localPermissionItem].includes(baseUrlName)
    );
  }
  return localPemissions[localPermission].includes(baseUrlName);
};

const EmptyComponent = () => <></>;

export const hasLocalAccessNode: HasLocalAccessNode = (localPermission, node) =>
  hasLocalAccess(localPermission) ? node : <EmptyComponent />;
